// Vue mounts after the first paint (see main.js) and replaces the
// server-rendered DOM, so code that works on that DOM must wait for the mount
// instead of DOMContentLoaded. Inline template scripts, which run before the
// bundle, listen for the APP_MOUNTED_EVENT document event.
export const APP_MOUNTED_EVENT = 'umall:app-mounted'

let isMounted = false

export function appMounted() {
  isMounted = true
  document.dispatchEvent(new Event(APP_MOUNTED_EVENT))
}

export function onAppMounted(callback) {
  if (isMounted) callback()
  else document.addEventListener(APP_MOUNTED_EVENT, callback, { once: true })
}

// `load` may already have fired by the time the app is mounted.
export function onWindowLoad(callback) {
  if ('complete' === document.readyState) callback()
  else window.addEventListener('load', callback)
}
